"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgSpeakerOff = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_SPEAKER-OFF", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "m6 4.516-2.777.49a.677.677 0 0 1-.088.008c-.327.015-.625.193-.739.501C2.218 5.997 2 6.825 2 8c0 .84.111 1.502.24 1.988l1.825-1.043A6.513 6.513 0 0 1 4 8c0-.455.041-.83.095-1.126l2.767-.488L10.68 3.28c.073.534.141 1.127.196 1.772l1.903-1.088a34.078 34.078 0 0 0-.303-2.145l-.004-.024a30.258 30.258 0 0 0-.289-1.433.473.473 0 0 0-.767-.25L6 4.515ZM15.868 4.504a1 1 0 0 1-.372 1.364l-2.503 1.43a36.253 36.253 0 0 1-.516 6.881l-.004.025a30.318 30.318 0 0 1-.289 1.433.473.473 0 0 1-.767.25L6 11.485l-.254-.044-4.25 2.428a1 1 0 1 1-.992-1.736l14-8a1 1 0 0 1 1.364.372ZM7.72 10.312l2.961 2.407c.16-1.169.296-2.622.316-4.28L7.72 10.312Z" }))); };
exports.default = SvgSpeakerOff;
